export default {
	"lineManage": {
		"city": "城市",
		"lineName": "线路名称",
		"station": "请选择站点",
		"lineCode": "线路编码",
		"lineType": "线路类型",
		"point": "点数",
		"lineInfo": "线路信息",
		"defaultStartDt": "默认发车时间",
		"stationNameFilter": "站点名称过滤",
		"index": "顺序",
		"addLineTitle": "添加线路",
		"importSiteTitle": "导入线路",
		"fixedLineTitle": "固定线路"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/lineManage/lineManage.js